import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	attributes: {
		color: "#AFA08B",
		"& span": {
			fontWeight: theme.typography.fontWeightBold
		}
	}
}));

export default styles;
